import React from "react";
import trophy from "./images/icons/trophy.png";
import { Image } from "react-bootstrap";
import Timeline from "./components/HorizontalTimeLine";
import {
  sectionHeadingStyle,
  sectionContainerStyle,
  headingContainerStyle,
} from "./components/styles";
const Achievements = () => {
  return (
    <div style={sectionContainerStyle}>
      <div style={headingContainerStyle}>
        <h2 style={sectionHeadingStyle}>Achievements</h2>{" "}
        <Image
          src={trophy}
          alt=""
          className="section-icon"
        />
      </div>

      <Timeline />
    </div>
  );
};

export default Achievements;
